<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in icon="Q" :title="title"></SectionTitle>
    <QuestionBox :title="questionTitle" :desc="questionDesc" :items="questionItem" v-on:selected="selected" :index="questionAnswer" ></QuestionBox>
    <GoNext class="animate-target" v-animate-in href="/section5/5-2" :selected="selectedValue" required="true"></GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt" />
  </div>
</template>

<script>

import SectionTitle from "../../components/SectionTitle";
import QuestionBox from "../../components/QuestionBox";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s5-1",
  components: {SectionTitle, QuestionBox, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return {
      questionTitle: "Question 1",
      questionDesc: "Guidelines recommend assessment of kidney function in T2D using:<sup>1</sup>",
      questionItem:[
          "Urinary albumin (UACR)",
          "Estimated glomerular filtration rate (eGFR)",
          "UACR and eGFR",
          "Blood pressure (BP)"
      ],
      selectedValue:'',
      questionAnswer:'2',
      noticeTxt:"CKD, chronic kidney disease, T2D, type 2 diabetes.<br/><div class='brs'></div>"
      +"Reference:<br/><div class='brs'></div>"
      +"1. RACGP. Management of type 2 diabetes: A handbook for general practice. <a target='_blank' class='c-url' href='https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx'>https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx</a>.",
      title:"Post-activity quiz"
    };
  },
  methods:{
    selected:function(value){
      this.selectedValue = value;
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section5/s5.css";
</style>
